import React from 'react';
import { ApiError } from '../../../../api/api';
import { ReadOnlyField } from '../../../../shared/form/ReadOnlyField';

type Props = {
  label: React.ReactNode;
  designCalculationsInProgress: boolean;
  designCalculationsError: ApiError | null;
  value: string | null;
  colour?: 'green' | 'yellow' | 'red' | null;
};

export const DesignCalculationReadOnlyField = ({
  label,
  designCalculationsInProgress,
  designCalculationsError,
  value,
  colour,
}: Props) => (
  <ReadOnlyField
    label={label}
    value={
      designCalculationsInProgress
        ? 'Calculating...'
        : designCalculationsError != null
        ? 'Error'
        : value != null && value !== 'NaN'
        ? value
        : '?'
    }
    showError={designCalculationsError != null}
    error={designCalculationsError && (designCalculationsError.userVisibleMessage || 'Failed to perform calculations')}
    colour={colour}
  />
);
